import { useContext, useEffect, useRef } from "react";
import globalStates from "../../utils/global";
import "./HomeScreen2.css"
import { ImgHomeScreen2Box1, ImgHomeScreen2Box2, ImgHomeScreen2Box3 } from "../../assets";

const HomeScreen2 = () =>{

    const context = globalStates && globalStates.globalContext;
    const globalContext:any = useContext(context);
    const windowWidthClass = globalContext && globalContext.windowWidthClass;
    
    // const businessDetailImagesImg = businessDetailImages && businessDetailImages.screenBannerImg;

    const screenHomeScreen2 = useRef(null) as any;
    // console.log({})
    useEffect(()=>{
        const handleScroll =()=>{
            const setScreensOffset = globalContext && globalContext.setScreensOffset;
            const screenWebsite = screenHomeScreen2.current.getBoundingClientRect();
            const top = screenWebsite.top;
            const bottom = screenWebsite.bottom;
            const offset = globalContext && globalContext.windowHeight;
            setScreensOffset((prev:any)=>{return {...prev, 
                isOffsetscreenHomeScreen2: false, bottom, offset, top
            }});
            if(top < (-1*0.005*offset) ){
                setScreensOffset((prev:any)=>{return {...prev, bottom, offset, top,
                    isOffsetscreenHomeScreen2: true,
                }});
            };
        };
        window.addEventListener('scroll', handleScroll);
        return () => {
        window.removeEventListener('scroll', handleScroll);
        };
    }, [globalContext])

    const componentData = {
        background: {
            image: {
                src: "",
                alt: ""
            }
        },
        shield: {

        },
        content: {
            images: {
                box1: {
                    alt: "",
                    src: ImgHomeScreen2Box1
                },
                box2: {
                    alt: "",
                    src: ImgHomeScreen2Box2
                },
                box3: {
                    alt: "",
                    src: ImgHomeScreen2Box3
                }
            }
        }
    }
    
    return(
        <>
            <div 
            ref={screenHomeScreen2} 
            className={`${windowWidthClass}-home-screen-2 wrapper`}>

                <div className="background">
                    <div className="frame">
                        {/* <img
                            alt = {componentData.background.image.alt}
                            src = {componentData.background.image.src}
                        /> */}
                    </div>
                </div>
                <div className="shield">

                </div>
                <div className="content display grid">
                    <h2>manifesting with REAL ACTIONS</h2>
                    <div className="wrapper">
                        <div className="item box-1">
                                <div className="frame">
                                    <img
                                        src={componentData.content.images.box1.src}
                                        alt={componentData.content.images.box1.alt}
                                    />
                                </div>
                        </div>
                        <div className="item box-2">
                                <div className="frame">
                                    <img
                                        src={componentData.content.images.box2.src}
                                        alt={componentData.content.images.box2.alt}
                                    />
                                </div>
                        </div>
                        <div className="item box-3">
                                <div className="frame">
                                    <img
                                        src={componentData.content.images.box3.src}
                                        alt={componentData.content.images.box3.alt}
                                    />
                                </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
        
    )
};

export default HomeScreen2;